<!-- Quick View Panel Code -->
<p-dialog id="ViewDialog" [(visible)]="caisExceptionServiceService.isCaisView" appendTo="body" height="auto"
  width="auto" (onHide)="caisExceptionServiceService.isCaisView=false;" [style]="{width: '78%', minWidth: '550px'}"
  [minY]="100" [maximizable]="true" minimizeIcon="pi pi-window-minimize" maximizeIcon="pi pi-window-maximize"
  closeIcon="pi pi-times" [modal]="false" draggable="true" styleClass= "view-fdid-form-dialog" [focusOnShow]="false">
  <ng-template #header class= "dialog-header">View {{screenType}}</ng-template>
    <div class="col-lg-12 nopadding">
      @if(isViewLoadingResults){
      <div class="example-loading-shade">
        @if(isViewLoadingResults){
        <mat-spinner></mat-spinner>
        }
      </div>
      }

      <div class="ui-grid-col-12 container">
        @if(showRecordDetails){
        <app-record-details [ExceptionCodeDetailsCols]="ExceptionCodeDetailsCols"
          [rowDataforDialog]="rowDataforDialog">
        </app-record-details>
        }

        <app-error-code-details [ExceptionCodesDetails]="ExceptionCodesDetails">
        </app-error-code-details>
        @if(this.rowDataforDialog['firmDesignatedID'] || this.rowDataforDialog['accountNumber'] ){
        <span>
          <mat-list-item class="list-item-title">FDID Details</mat-list-item>
          <mat-divider></mat-divider>
          @for(viewRow of fdidScreenDataDetails; track viewRow; let i = $index){
            @if(!viewRow.isOptionalFields){
              <span
                [ngClass]="(viewScreenNegotiatedFields.includes(viewRow.ui_Field_Name) || ExceptionalFDIDScreenFields.includes(viewRow.ui_Field_Name) ? 'notdisplay' : (viewRow.isLargeField ? 'zindex ui-g-12 ui-md-12 ui-lg-6' : 'zindex ui-g-12 ui-md-12 ui-lg-4'))">
                <span>
                  <div class="ui-g-12 ui-md-12 ui-lg-12 quick-view-grid-row-hg">
                    <div
                      [ngClass]="(viewRow.isLargeField ? 'ui-g-12 ui-md-4 ui-lg-4 quick-view-grid-row-hg' : 'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg')">
                      <label for="ui_Field_Name">{{viewRow.ui_Field_Name}}</label>
                    </div>
                    <div
                      [ngClass]="(viewRow.isLargeField ? 'ui-g-12 ui-md-8 ui-lg-8 quick-view-grid-row-hg' : 'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg')">
                      <span>
                        <input [disabled]="true" pInputText [(ngModel)]="FDIDScreenDataDetails[viewRow.field_Name]"
                          [title]="FDIDScreenDataDetails[viewRow.field_Name]" />
                      </span>
                    </div>
                  </div>
                </span>
              </span>
            }
          }
        </span>
        }
      </div>
      @if(this.rowDataforDialog['firmDesignatedID'] || this.rowDataforDialog['accountNumber']){
      <div>
        <mat-divider></mat-divider>
        <!-- LTID Details -->
        @if(caisServiceService.hasAnyActiveField(LTIDcols)) {
          <mat-list-item class="list-item-title">LTID Details</mat-list-item>
          <div class="ui-grid-col-12 container">
            <p-table class="view-fdid-form-table" id="ViewLTIDTable" [columns]="LTIDcols" [value]="LTIDDataSet" scrollHeight="100px" #view_LTDT>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length" class="text-center">
                    {{constantService.NO_RECORDFOUND_MSG}}
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="header" let-columns let-rowIndex=rowIndex>
                <tr>
                  @for(col of columns; track col;){
                  <th id="columns" [ngClass]=" (col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
                    {{col.header}}
                  </th>
                }
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row let-columns="columns" let-rowIndex="rowIndex">
                <tr>
                  @for(col of columns; track col;){
                  <td [ngClass]=" (col?.display | lowercase) == 'false' ? 'notdisplay':'' ">
                    <span>{{row[col.field]}}</span>
                  </td>
                }
                </tr>
              </ng-template>
            </p-table>
          </div>
        }
        <!-- End of LTID Details -->

        <mat-divider></mat-divider>
        <!-- Address Details -->
        @if(caisServiceService.hasAnyActiveField(addressColumns)) {
          <mat-list-item class="list-item-title">Address Details</mat-list-item>
          <div class="ui-grid-col-12 container">
            <p-table class="view-fdid-form-table" id="ViewFDIDAddressTable" [columns]="addressColumns" [value]="FDIDAddressDetails" #dt2>
              <ng-template pTemplate="header" let-columns>
                <tr>
                  @for(col of columns; track col;){
                  <th id="columns" [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':''">
                    {{col.header}}
                  </th>
                }
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-addressRowData let-ri="rowIndex" let-columns="columns">
                <tr [pSelectableRow]="addressRowData">
                  @for(col of columns; track col;){
                  <td [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':''">
                    <span>
                      {{addressRowData[col.field]}}
                    </span>
                  </td>
                }
                </tr>
              </ng-template>
            </p-table>
          </div>
        }
        <!-- End of Address Details -->

        <mat-divider></mat-divider>
        <mat-list-item class="list-item-title">Natural Person/Legal Entity List Details</mat-list-item>
        <!-- Natural Person/Legal Entity List -->
        <div class="ui-grid-col-12 container card tabView-container">
            <p-tabs class="view-tab" [id]="'viewNaturalPersonLegalEntityTab'" [value]="selectedTabIndex" scrollable>
              <p-tablist>
                @for(NaturalPerson of (NaturalPersons | slice:1); track NaturalPerson.tabIndex + '-'+ $index;let i = $index){
                <p-tab [value]="NaturalPerson.tabIndex" [ngClass]="NaturalPersonDataDetails[i]?.tidUpdate===caisServiceService.TIDUpdateStatuses[0] ? 'preTIDUpdateHeader' : (NaturalPersonDataDetails[i]?.tidUpdate===caisServiceService.TIDUpdateStatuses[1] ? 'postTIDUpdateHeader' : '')">
                  {{NaturalPerson.name}}
                </p-tab>
                }
                @for(LegalEntity of (LegalEntities | slice:1); track LegalEntity.tabIndex + '-'+ $index;let i = $index){
                <p-tab [value]="LegalEntity.tabIndex" [ngClass]="LegalEntityDataDetails[i]?.tidUpdate===caisServiceService.TIDUpdateStatuses[0] ? 'preTIDUpdateHeader' : (LegalEntityDataDetails[i]?.tidUpdate===caisServiceService.TIDUpdateStatuses[1] ? 'postTIDUpdateHeader' : '')">
                  {{LegalEntity.name}}
                </p-tab>
                }
              </p-tablist>
              <p-tabpanels>
                @for(NaturalPerson of (NaturalPersons | slice:1); track NaturalPerson.tabIndex + '-'+ $index;let i = $index){
                <ng-container>
                  <p-tabpanel [value]="NaturalPerson.tabIndex" [id]="NaturalPerson.id">
                    @if(caisExceptionServiceService.isCaisView){
                    <div class="ui-grid-col-12 container contents">
                      <!-- Natural Person Fields -->
                      @for(viewRow of NaturalPersonScreenDataDetails; track viewRow.ui_Field_Name + '-'+ $index) {
                        @if(!viewRow.isOptionalFields){
                          <span
                            [ngClass]="viewScreenNegotiatedFields.includes(viewRow.ui_Field_Name) || (viewRow?.display | lowercase) == 'false' ? 'notdisplay':'' ">
                            <span
                              [ngClass]="(viewRow.isLargeField ? 'zindex ui-g-12 ui-md-12 ui-lg-6' : 'zindex ui-g-12 ui-md-12 ui-lg-4')">
                              <div class="ui-g-12 ui-md-12 ui-lg-12 quick-view-grid-row-hg">
                                <div
                                  [ngClass]="(viewRow.isLargeField ? 'ui-g-12 ui-md-4 ui-lg-4 quick-view-grid-row-hg' : 'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg')">
                                  <label for="ui_Field_Name">{{viewRow.ui_Field_Name}}</label>
                                </div>
                                <div
                                  [ngClass]="(viewRow.isLargeField ? 'ui-g-12 ui-md-8 ui-lg-8 quick-view-grid-row-hg' : 'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg')">
                                  @if(viewRow.field_Name !='yearOfBirth'){
                                  <span>
                                    <ng-container>
                                      <input pInputText [id]="viewRow.field_Name+'string'"
                                        [(ngModel)]="NaturalPersonDataDetails[i][viewRow.field_Name]" [disabled]="true"
                                        [title]="NaturalPersonDataDetails[i][viewRow.field_Name]" />
                                    </ng-container>
                                  </span>
                                  }
                                  @if(viewRow.field_Name =='yearOfBirth'){
                                  <span>
                                    <input pInputText inputId="birthYear" class="birthYear" [id]="viewRow.field_Name+i" [disabled]="viewRow.isDisable"
                                      [(ngModel)]="NaturalPersonDataDetails[i][viewRow.field_Name]"
                                      (keyup)="caisServiceService.maskYear()" (focus)="caisServiceService.unMaskYear(viewRow.value)"
                                      (focusout)="caisServiceService.maskYear()" />
                                  </span>
                                  }
                                </div>
                              </div>
                            </span>
                          </span>
                        }
                      }
                      <!-- End of Natural Person Fields -->
                    </div>
                    }
                    <!-- View Natural Person Address Details -->
                    @if(caisServiceService.hasAnyActiveField(addressColumns)) {
                      <div class="ui-grid-col-12 container contents">
                        <p-table id="ViewNaturalPersonAddressTable" [columns]="addressColumns"
                          [value]="NaturalPersonAddressDetails[i]" class="AddressTable view-fdid-form-table" #view_dt>
                          <ng-template pTemplate="header" let-columns>
                            <tr>
                              @for(col of columns; track col.header + '-'+ $index) {
                              <th id="colHeader" [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':''">
                                {{col.header}}
                              </th>
                              }
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="body" let-columns="columns" let-rowData let-ri="rowIndex">
                            <tr [pSelectableRow]="rowData">
                              @for(col of columns; track col.field + '-'+ $index) {
                              <td [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':''">
                                <span>
                                  {{rowData[col.field]}}
                                </span>
                              </td>
                              }
                            </tr>
                          </ng-template>
                        </p-table>
                      </div>
                    }
                    <!-- End of View Natural Person Address Details -->
                  </p-tabpanel>
                </ng-container>
                }
                @for(LegalEntity of (LegalEntities | slice:1); track LegalEntity.tabIndex + '-'+ $index;let i = $index){
                <ng-container>
                  <p-tabpanel [value]="LegalEntity.tabIndex" [id]="LegalEntity.id">
                    @if(caisExceptionServiceService.isCaisView){
                    <div class="ui-grid-col-12 container contents">
                      <!-- Legal Entity Fields -->
                      @for(viewRow of LegalEntityScreenDataDetails; track viewRow.ui_Field_Name + '-'+ $index) {
                        @if(!viewRow.isOptionalFields){
                          <span
                            [ngClass]="viewScreenNegotiatedFields.includes(viewRow.ui_Field_Name) || (viewRow?.display | lowercase) == 'false' ? 'notdisplay':'' ">
                            <span
                              [ngClass]="(viewRow.isLargeField ? 'zindex ui-g-12 ui-md-12 ui-lg-6' : 'zindex ui-g-12 ui-md-12 ui-lg-4')">
                
                              <div class="ui-g-12 ui-md-12 ui-lg-12 quick-view-grid-row-hg">
                                <div
                                  [ngClass]="(viewRow.isLargeField ? 'ui-g-12 ui-md-4 ui-lg-4 quick-view-grid-row-hg' : 'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg')">
                                  <label for="ui_Field_Name">{{viewRow.ui_Field_Name}}</label>
                                </div>
                                <div
                                  [ngClass]="(viewRow.isLargeField ? 'ui-g-12 ui-md-8 ui-lg-8 quick-view-grid-row-hg' : 'ui-g-12 ui-md-6 ui-lg-6 quick-view-grid-row-hg')">
                                  <span>
                                    <ng-container>
                                      <input pInputText [id]="viewRow.field_Name+'string'"
                                        [(ngModel)]="LegalEntityDataDetails[i][viewRow.field_Name]"
                                        [title]="LegalEntityDataDetails[i][viewRow.field_Name]" [disabled]="true" />
                                    </ng-container>
                                  </span>
                                </div>
                              </div>
                            </span>
                          </span>
                        }
                      }
                      <!-- End of Legal Entity Fields -->
                    </div>
                    }
                    <!-- View Legal Entity Address Details -->
                    @if(caisServiceService.hasAnyActiveField(addressColumns)) {
                      <div class="ui-grid-col-12 container contents">
                        <p-table id="ViewLegalEntityAddressTable" [columns]="addressColumns" [value]="LegalEntityAddressDetails[i]"
                          class="AddressTable view-fdid-form-table" #view_dt>
                          <ng-template pTemplate="header" let-columns>
                            <tr>
                              @for(col of columns; track col.field + '-'+ $index) {
                              <th id="colHeader" [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':''">
                                {{col.header}}
                              </th>
                              }
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="body" let-columns="columns" let-rowData let-ri="rowIndex">
                            <tr [pSelectableRow]="rowData">
                              @for(col of columns; track col.field + '-'+ $index) {
                              <td [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':''">
                                <span>
                                  {{rowData[col.field]}}
                                </span>
                              </td>
                              }
                            </tr>
                          </ng-template>
                        </p-table>
                      </div>
                    }
                    <!-- End of View Legal Entity Address Details -->
                  </p-tabpanel>
                </ng-container>
                }
              </p-tabpanels>
            </p-tabs>     
        </div>
        <!-- End of Natural Person/Legal Entity List -->

      </div>
      }
    </div>
    <ng-template #footer>
    <div>
      <p-button class="view-fdid-footer-button" icon="fa fa-close" id="CloseViewDialog" (click)="caisExceptionServiceService.isCaisView=false;"
        label="Close"></p-button>
    </div>
    </ng-template>

</p-dialog>
<!-- End of Quick View Panel Code -->